export default __webpack_public_path__ + "static/page_pp_d-1e08b202541d8d17c75002dfea594d86.png";